var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Log } from '@servicetitan/log-service';
import { injectDependency, optional } from '@servicetitan/react-ioc';
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                hasError: false,
            }
        });
    }
    componentDidCatch(error) {
        if (this.logService) {
            const { moduleName: Module, getErrorData } = this.props;
            const data = { Module, ...getErrorData === null || getErrorData === void 0 ? void 0 : getErrorData(error) };
            this.logService.error({ error, message: error.message, data });
        }
        this.setState({ hasError: true }); // eslint-disable-line react/no-set-state
    }
    render() {
        const { fallback: Fallback = DefaultFallback } = this.props;
        const { hasError } = this.state;
        if (hasError) {
            const handleRefresh = () => {
                this.setState({ hasError: false }); // eslint-disable-line react/no-set-state
            };
            return _jsx(Fallback, { onRefresh: handleRefresh });
        }
        return this.props.children;
    }
}
__decorate([
    optional(),
    injectDependency(Log),
    __metadata("design:type", Log)
], ErrorBoundary.prototype, "logService", void 0);
const DefaultFallback = () => _jsx("h2", { children: "Something went wrong" });
//# sourceMappingURL=error-boundary.js.map